import { Indicator } from "@mantine/core";

import type { JSX } from "react";

interface ActivityBubbleProps {
    variant: "available" | "offline" | "custom";
    size?: number;
}

const variantToColor: Record<ActivityBubbleProps["variant"], string> = {
    available: "var(--mantine-color-success-4)",
    offline: "var(--mantine-color-gray-6)",
    custom: "var(--mantine-color-red-5)",
};

export function ActivityBubble({ variant, size }: ActivityBubbleProps): JSX.Element {
    const color = variantToColor[variant];
    return <Indicator color={color} inline mx="xs" offset={7} position="middle-center" size={size ?? 12} withBorder />;
}
